// extracted by mini-css-extract-plugin
module.exports = {"label":"ForestTitleEdit_label__QVjkM","input":"ForestTitleEdit_input__UZTXb","count":"ForestTitleEdit_count__PZU4u","buttons":"ForestTitleEdit_buttons__NBA93"};